import { isDayChecked } from '../../utils/dates'
import { Chip } from './fields/Chip'
import { daysOfTheWeekOptions } from '../settings/Options'

type Props = {
    schedule?: number
    onChange: (schedule: number) => void
}

export function SelectDaysOfTheWeek({ schedule, onChange }: Props) {
    return (
        <div className="flex flex-wrap gap-2">
            {daysOfTheWeekOptions.map((option) => (
                <Chip
                    size="small"
                    key={option.value}
                    title={option.label}
                    isSelected={isDayChecked(schedule, option.value)}
                    onClick={() =>
                        onChange(
                            schedule
                                ? parseInt(schedule.toString()) ^ parseInt(option.value)
                                : parseInt(option.value)
                        )
                    }
                />
            ))}
        </div>
    )
}
